export default {
  data() {
    return {
      infoWindow: {
        id: 0,
        content: '',
        open: false,
        position: {
          lat: -8.504455,
          lng: 115.262349,
        },
        options: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
      },
    };
  },

  methods: {
    // close info window when default 'x' is clicked
    closeInfoWindow() {
      this.infoWindow.open = false;
    },
  },
};
